/* ============================================================================
   The Glow Up Guide — V2 shared JS (homepage hero, hub, mini upgrade).
   Theme-editor safe: shows content in Shopify.designMode, re-binds on
   shopify:section:load, and reveal-hiding only applies once .gugv2-js is on
   <html> (content is never stuck invisible if JS fails).
   Reveal threshold is 0 on purpose (tall elements never clear a higher one).
   ============================================================================ */
(function () {
  if (window.__gugV2Init) return;
  window.__gugV2Init = true;

  document.documentElement.classList.add('gugv2-js');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  /* ---------- reveal-on-scroll ---------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.gugv2-reveal:not(.gugv2-in)');
    if (!els.length) return;
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('gugv2-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('gugv2-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- homepage hero city switcher (rev 4) ----------
     Any number of cities: tabs and panels are keyed positionally (c1, c2...).
     Panel order = block order, first block is the default city. Reads
     ?city=<slug|cN> / #<slug> first, then sessionStorage, then falls back to
     the server-rendered default. Sets data-gugsw-active on the section so
     every [data-city] element on the page (perk rows, guide groups) follows.  */
  function initCitySwitch(root) {
    (root || document).querySelectorAll('[data-gugsw]').forEach(function (sw) {
      if (sw.__gugBound) return;
      sw.__gugBound = true;
      var scope = sw.closest('.gugsh') || sw.closest('section') || document;
      var tabs = Array.prototype.slice.call(scope.querySelectorAll('[data-gugsw-tab]'));
      var panels = Array.prototype.slice.call(sw.querySelectorAll('[data-gugsw-panel]'));
      if (!panels.length) return;
      sw.classList.add('gugsw-ready');

      function keyFor(value) {
        if (!value) return null;
        var v = String(value).toLowerCase();
        for (var i = 0; i < panels.length; i++) {
          var p = panels[i];
          if (p.getAttribute('data-gugsw-panel') === v) return v;
          if ((p.getAttribute('data-gugsw-slug') || '').toLowerCase() === v) return p.getAttribute('data-gugsw-panel');
        }
        return null;
      }

      function activate(key, opts) {
        var o = opts || {};
        if (!key) return;
        if (o.instant) { sw.classList.add('gugsw-instant'); }
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-gugsw-tab') === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
        });
        panels.forEach(function (p) {
          var on = p.getAttribute('data-gugsw-panel') === key;
          /* re-trigger the entrance animation on every switch */
          p.classList.remove('is-active');
          if (!on) return;
          void p.offsetWidth;
          p.classList.add('is-active');
          /* the newly shown city owns the LCP image, so stop deferring it */
          var lead = p.querySelector('.gugh4-img');
          if (lead && lead.getAttribute('loading') === 'lazy') { lead.setAttribute('loading', 'eager'); }
        });
        if (scope.setAttribute) scope.setAttribute('data-gugsw-active', key);
        if (o.instant) { window.setTimeout(function () { sw.classList.remove('gugsw-instant'); }, 60); }
        if (!o.silent) {
          try { window.sessionStorage.setItem('gugCity', key); } catch (err) { /* private mode */ }
        }
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { activate(tab.getAttribute('data-gugsw-tab')); });
        tab.addEventListener('keydown', function (ev) {
          var next = null;
          if (ev.key === 'ArrowRight' || ev.key === 'ArrowDown') next = tabs[(i + 1) % tabs.length];
          else if (ev.key === 'ArrowLeft' || ev.key === 'ArrowUp') next = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (ev.key === 'Home') next = tabs[0];
          else if (ev.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          ev.preventDefault();
          activate(next.getAttribute('data-gugsw-tab'));
          next.focus();
        });
      });

      /* initial state: URL wins, then the session, else the rendered default */
      var wanted = null;
      try {
        var params = new URLSearchParams(window.location.search);
        wanted = keyFor(params.get('city')) || keyFor((window.location.hash || '').replace('#', ''));
      } catch (err) { /* older browsers: skip deep linking */ }
      var fromSession = null;
      if (!wanted) {
        try { fromSession = keyFor(window.sessionStorage.getItem('gugCity')); } catch (err) { /* private mode */ }
      }
      var active = wanted || fromSession;
      var current = (panels.filter(function (p) { return p.classList.contains('is-active'); })[0] || panels[0]).getAttribute('data-gugsw-panel');
      if (active && active !== current) {
        activate(active, { instant: true, silent: !wanted });
      } else if (scope.setAttribute) {
        scope.setAttribute('data-gugsw-active', current);
      }
      /* a campaign link wins for the rest of the session too */
      if (wanted) {
        try { window.sessionStorage.setItem('gugCity', wanted); } catch (err) { /* private mode */ }
      }
    });
  }

  /* ---------- hero destination crossfade ----------
     Slow, dot-free, opacity only. Skipped for reduced motion, in the theme
     editor, while the panel is hidden and while the tab is in the background. */
  function initHeroFade(root) {
    if (reduce || designMode) return;
    (root || document).querySelectorAll('[data-gugh4-fade]').forEach(function (box) {
      if (box.__gugBound) return;
      box.__gugBound = true;
      var imgs = Array.prototype.slice.call(box.querySelectorAll('.gugh4-img'));
      if (imgs.length < 2) return;
      var i = 0;
      window.setInterval(function () {
        if (document.hidden || !box.offsetParent) return;
        imgs[i].classList.remove('is-on');
        i = (i + 1) % imgs.length;
        imgs[i].classList.add('is-on');
      }, 5600);
    });
  }

  function init(root) {
    initReveals(root);
    initCitySwitch(root);
    initHeroFade(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
